function CompaniesSection() {
  return (
    <section className="mx-auto -mt-12 w-[calc(100%-2rem)] max-w-6xl rounded-lg bg-[#ededed] px-4 py-7 md:w-[calc(100%-8rem)]">
      <div className="flex flex-wrap items-center justify-center gap-x-7 gap-y-5">
        <img
          src={require("../../asset/image/hts.png")}
          alt="HTS"
          className="h-[28px] w-[120px]"
        />
        <img
          src={require("../../asset/image/tru.png")}
          alt="TRU"
          className="h-[40px] w-[74px]"
        />
        <img
          src={require("../../asset/image/tangerine.png")}
          alt="Tangerine"
          className="h-[45px] w-[138px]"
        />
        <img
          src={require("../../asset/image/1ubank.png")}
          alt="1UBank"
          className="h-[49px] w-[123px]"
        />
      </div>
    </section>
  );
}

export default CompaniesSection;
